export default {
    data: () => ({
        btnLoading: false,
        server_errors: {
            transport_type: '',
            address_country: '',
            shipping_rates: '',
            volumetric_weight_formula: '',
        },
        value: {
            transport_type: 'normal',
            address_country: 'zh',
            shipping_rates: '',
            volumetric_weight_formula: '',
        },
        transportTypes: [
            { id: 'normal', name: 'ປົກກະຕິ ( Normal )' },
            { id: 'air_freight', name: 'ທາງຍົນ ( Air Freight )' },
            { id: 'railway', name: 'ທາງລົດໄຟ ( Railway )' },
        ],
        addressCountries: [
            { id: 'zh', name: 'ຈີນ ( ZH )' },
            { id: 'th', name: 'ໄທ ( TH )' },
        ],
    }),
    methods: {
        ValidateForm() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.SaveItem();
                }
            });
        },
        SaveItem() {
            this.btnLoading = true;
            this.$http.post('shipping-rate', this.value).then((res) => {
                if (res.data && res.data.error === false) {
                    setTimeout(() => {
                        this.btnLoading = false;
                        this.$emit('close');
                        this.$emit('success');
                        this.$notification.OpenNotification_AddItem_OnSuccess('top-right', 'dark', 3000);
                    }, 300);
                } else {
                    this.btnLoading = false;
                    this.$notification.OpenNotification_Error_Server('top-right', 'danger', 3000);
                }
            }).catch((error) => {
                this.btnLoading = false;
                if (error.response && error.response.status === 422) {
                    const obj = error.response.data.errors || {};
                    for (const [key, value] of Object.entries(obj)) {
                        this.server_errors[key] = value[0];
                    }
                } else {
                    this.$notification.OpenNotification_Error_Server('top-right', 'danger', 3000);
                }
            });
        },
    },
    watch: {
        'value.transport_type': function () { this.server_errors.transport_type = ''; },
        'value.address_country': function () { this.server_errors.address_country = ''; },
        'value.shipping_rates': function () { this.server_errors.shipping_rates = ''; },
        'value.volumetric_weight_formula': function () { this.server_errors.volumetric_weight_formula = ''; },
    },
};
